extend = require 'extend'
{ authTools } = require '../../../shared/js/lib/authTools'
{ did, doing } = require './common'
{ UPDATED_CURRENT_USER, UPDATING_CURRENT_USER } = require '../actions/users'
Immutable = require('seamless-immutable')
{ CHECKING_TOKEN, CHECKED_TOKEN, LOGGING_IN, LOGGED_IN, LOG_OUT } = require '../actions/auth'
{ REFRESH_TOKEN } = require '../actions/token'

baseState = Immutable(extend(true, authTools.hydrateState(localStorage),
	isAuthenticating: false
	isCheckingToken: false
	loginPrompt: null
))

auth = (state = baseState, action) ->
	forceLogoutState = (state) ->
		state = state.set 'isAuthenticated', false
		state = state.set 'token', null
		state = state.set 'user', null
		state = state.set 'loginPrompt', null
		state = state.set 'errorMessage', null
		state = state.set 'exp', 0

	refreshLocalStorageFromState = (state) ->
		localStorage.setItem 'auth', JSON.stringify({ token: state.token, user: state.user })

	switch action.type
		when CHECKING_TOKEN
			state = state.set 'isCheckingToken', true
		when CHECKED_TOKEN
			state = state.set 'isCheckingToken', false
		when LOGGING_IN
			state = state.set 'isAuthenticating', true
		when LOGGED_IN
			state = state.set 'isAuthenticating', false
			if action.error
				state = state.set 'errorMessage', action.payload.message
			else
				state = state.set 'isAuthenticated', true
				state = state.set 'token', action.payload.token
				state = state.set 'user', action.payload.user
				state = state.set 'loginPrompt', null
				state = state.set 'errorMessage', null
				state = state.set 'exp', action.payload.exp
		when LOG_OUT
			state = forceLogoutState state
		when REFRESH_TOKEN
			state = state.set 'token', action.payload.token
		when UPDATING_CURRENT_USER
			state = doing 'isUpdating', state
		when UPDATED_CURRENT_USER
			state = state.set 'isUpdating', false
			state = state.set 'user', action.payload.modified
			refreshLocalStorageFromState(state)
	state

module.exports = auth



// WEBPACK FOOTER //
// ./frontend/olos/js/reducers/auth.coffee